import { render } from "./DocumentoEditorComponent.vue?vue&type=template&id=5eb808b8"
import script from "./DocumentoEditorComponent.vue?vue&type=script&lang=js"
export * from "./DocumentoEditorComponent.vue?vue&type=script&lang=js"

import "./DocumentoEditorComponent.vue?vue&type=style&index=0&id=5eb808b8&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__